import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowBottomRightCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-bottom-right-corner"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowBottomRightCorner"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM10.293 11L16.293 17H11V18H18V11H17V16.293L11 10.293L10.293 11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowBottomRightCorner;
